import { Component } from 'react'
import { Popover, PopoverBody } from 'reactstrap'
import { isAdmin } from 'utils/authService'
import s from './Settings.scss'
import { withRouter } from 'hocs'
import { URLS } from 'utils/constants'
import cn from 'classnames'
import { FontIcon } from 'components/Dashboard/icons/FontIcon'
import { FaMailBulk, FaQuestionCircle } from 'react-icons/fa'

let forceClose = false

@withRouter
class Settings extends Component {
  state = {
    popoverOpen: false
  }

  componentDidUpdate() {
    if (this.state.popoverOpen && forceClose) {
      forceClose = false
      this.closePopover()
    }
  }

  closePopover = () => {
    this.setState({ popoverOpen: false })
  }

  toggle = () => {
    this.setState(prevState => ({
      popoverOpen: !prevState.popoverOpen
    }))
  }

  redirect = page => {
    forceClose = true
    this.toggle()
    this.props.router.navigate(`${URLS.AUTH_ADMIN}?tab=${page}`)
  }

  render() {
    return (
      <Popover
        className={s.settingsPopover}
        placement="bottom"
        isOpen={this.state.popoverOpen}
        target={this.props.settingsTarget}
        toggle={this.toggle}
        trigger="legacy"
      >
        <PopoverBody className={s.settingsPopoverBody}>
          <div
            onClick={() => this.redirect('profile')}
            className={cn(s.settingsButton, s.settingsFirstButton)}
          >
            <FontIcon icon="FaUser" className={s.menuIcon} color="#727479" size="1.2em" />
            Profile
          </div>
          <div
            onClick={() => this.redirect('personalSettings')}
            className={cn(s.settingsButton, s.settingsFirstButton)}
          >
            <FontIcon icon="FaUserCog" className={s.menuIcon} color="#727479" size="1.5em" />
            Personal Settings
          </div>
          {isAdmin() && (
            <>
              <div onClick={() => this.redirect('organization')} className={s.settingsButton}>
                <FontIcon icon="FaBuilding" className={s.menuIcon} color="#727479" size="1.2em" />
                Organization
              </div>
            </>
          )}
          <div
            onClick={() => this.redirect('emails')}
            className={cn(s.settingsButton, s.settingsFirstButton)}
          >
            <FaMailBulk className={s.icon} />
            Sent Emails
          </div>
          <div
            onClick={() => this.redirect('help')}
            className={cn(s.settingsButton, s.settingsFirstButton)}
          >
            <FaQuestionCircle className={s.icon} />
            Help
          </div>
        </PopoverBody>
      </Popover>
    )
  }
}

export default Settings
